export class ImageSnippet {

    public pending = false;
    public status = 'init';
  
    constructor(public src: string, public file: File) { }
  }